module.exports = __webpack_public_path__ + "img/shopping-cart.4e47bb1d.svg";